import { Gtag } from "@/services/gtag";
import { B2cCategory } from "@/generated/graphql/b2c.ts";
import { Services } from "@/services/services.ts";

type ItemNameFormatter = {
  mpnFormatted?: string;
  productInfo?: {
    name: string;
  };
  brand?: {
    name: string;
  };
};

export const googleEvent = (eventName: string, value = "", label = "") => {
  Gtag.pushEvent(eventName, value, label);
};

export const getCategoriesEcommerceItems = (categories: B2cCategory[], services: Services) => {
  const returnCategories: { [key: string]: string } = {};
  for (let j = 0; j < categories.length; j++) {
    returnCategories["item_category" + (j !== 0 ? j + 1 : "")] = services.categories.getItem(categories[j].id).name;
  }

  return returnCategories;
};

export const getItemName = (item: ItemNameFormatter) => {
  return `${item.mpnFormatted ?? ""} ${item.brand?.name ?? ""} ${item.productInfo?.name ?? ""}`;
};
